module.exports = __webpack_public_path__ + "static/applicant-dashboard-c3604e0e7da2b790142eee06477e479e.png";